/**
 * Shopify Embedded App onboarding page.
 *
 * Rendered inside the Shopify Admin iframe via App Bridge.
 * Provides a single CTA that breaks out of the iframe and
 * redirects the merchant to our main application with a
 * query parameter that triggers the auto demo-login flow.
 */
import { useLocation } from 'react-router-dom'
import { AppProvider, Page, Layout, Card, Text, Button, BlockStack, Box } from '@shopify/polaris'
import enTranslations from '@shopify/polaris/locales/en.json'
import '@shopify/polaris/build/esm/styles.css'

const ShopifyOnboarding: React.FC = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const shop = params.get('shop') || ''
  const session = params.get('session') || ''

  const handleVisitDashboard = () => {
    const targetUrl = `${window.location.origin}/login?status=public_install_success&session=${session}`
    window.open(targetUrl, '_blank')
  }

  return (
    <AppProvider i18n={enTranslations}>
      <Page>
        <Layout>
          <Layout.Section>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
              <div style={{ maxWidth: '500px', width: '100%' }}>
                <Card>
                  <BlockStack gap="400" inlineAlign="center">
                    <img
                      src="/lyftr-logo.jpg"
                      alt="Lyftr AI"
                      style={{
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        objectFit: 'contain',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                      }}
                      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                        e.currentTarget.style.display = 'none'
                      }}
                    />
                    
                    <Text variant="headingXl" as="h4" alignment="center">
                      Welcome to Lyftr AI
                    </Text>

                    <Text variant="bodyLg" as="p" tone="subdued" alignment="center">
                      {shop ? (
                        <>Your Shopify store <b>{shop}</b> is successfully connected!</>
                      ) : (
                        'Your Shopify store is successfully connected!'
                      )}{' '}
                      Click below to access your AI-powered dashboard.
                    </Text>

                    <Box paddingBlockStart="400">
                      <Button variant="primary" size="large" onClick={handleVisitDashboard}>
                        Visit Lyftr AI Dashboard
                      </Button>
                    </Box>
                  </BlockStack>
                </Card>
              </div>
            </div>
          </Layout.Section>
        </Layout>
      </Page>
    </AppProvider>
  )
}

export default ShopifyOnboarding
